import { CircularProgress } from '@mui/material';
import { ICON_SIZE_MAP } from '@/config';

export function SelectLoadingIcon() {
  return <CircularProgress size={ICON_SIZE_MAP.smPlus} sx={{ mr: 1 }} />;
}
